// У автора Books.vue
<template>
  <div>
    <mercy-list></mercy-list>
  </div>
</template>

<script>
import MercyList from '../components/MercyList.vue'
export default {

  // computed: {
  //    isUserAuthentificated() {
  //       return this.$store.getters.isUserAuthentificated
  //    }
  // },
  
  components: {
    MercyList
  },
  // computed: {
  //   reload() {
  //     window.location.reload();
  //     return null;
  //   }
  // }
}
</script>

<style>

</style>